import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-nb-checkbox',
  template: `
<div class="row">
  <div class="col-4 d-flex align-items-center">
      <label for="input" class="form-label
      ">{{ to.label }}</label>
  </div>
  <div class="col-8 mb-2">
    <nb-checkbox fullWidth [checked]="formControl.value" (checkedChange)="formControl.setValue($event)">{{ to.label }}</nb-checkbox>
  </div>
</div>
  `,
})
export class FormlyFieldNbCheckbox extends FieldType {}
